import React, { Component } from 'react';
import TradeTable from './TradeTable';

class Company extends Component {

    state = {
        buy: false,
        sell: false,
    }

    newRecord = (information, type) => {
        this.activate(type, false);
        this.props.newTrade(information, type);
    }

    activate = (order, condition) => {
        this.setState({
            [order]: condition
        });
    }

    formatNumber = (x) => {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    
    render() {
        let sharesBought = 0;
        let sharesSold = 0;

        let boughtValue = 0;
        let soldValue = 0;

        let isLoss = false;

        let netGains = 0;

        if(this.props.companies) {
            const bought = this.props.companies.buy[this.props.name];
            const sold = this.props.companies.sell[this.props.name];

            if(bought !== undefined) {
                for(const item in bought) {
                    const data = bought[item];
                    sharesBought += parseInt(data.amount);
                    boughtValue += (parseFloat(data.price) * parseFloat(data.amount));
                }
            }

            if(sold !== undefined) {
                for(const item in sold) {
                    const data = sold[item];
                    sharesSold += parseInt(data.amount);
                    soldValue += (parseFloat(data.price) * parseFloat(data.amount));
                }
            }

            netGains = soldValue - boughtValue;

            if(boughtValue > soldValue) {
                isLoss = true;
                netGains = Math.abs(netGains);
            }
        }

        // this is really stupid
        // attention:
        // the buy and sell tables below have flipped input data i.e. the buy table receives the sell data from the DB
        // this is because the sell data references sales mades by others to you, therefore your 'buys' are their 'sells'
    
        return (
            <div className="company">
                <div className="companyHeader">
                    <div className="name">
                        { this.props.name }
                    </div>
                    <div className="companyMetrics">
                        <h5>Shares Owned: <span className="stocks_small">{ this.formatNumber(sharesBought - sharesSold) }</span></h5>
                        <h5>Profit/Loss: <span className={"money_small " + ((isLoss) ? "loss" : "")}>{ ((isLoss) ? "-$" : "+$" ) + this.formatNumber(netGains.toFixed(2)) }</span></h5>
                    </div>
                </div>
                <div className="trading-tables">
                    <TradeTable type="buy" 
                    name={this.props.name}
                    active={this.state.buy} 
                    activate={this.activate} 
                    data={(this.props.companies) ? this.props.companies.buy[this.props.name] : null}
                    newRecord={this.newRecord}
                    removeTrade={this.props.removeTrade} />

                    <TradeTable type="sell"
                    name={this.props.name}
                    active={this.state.sell} 
                    activate={this.activate} 
                    data={(this.props.companies) ? this.props.companies.sell[this.props.name] : null}
                    newRecord={this.newRecord}
                    removeTrade={this.props.removeTrade} />
                </div>
            </div>
        );
    }
}

export default Company;